<template>
  <div class="project-detail">
    <el-collapse v-model="activeCollapses" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基础信息
          </div>
        </template>
        <div class="collapse-content">
          <!-- isQueryPanel代表可以作为form使用，不需要搜索 -->
          <SiruiSearch
            ref="baseInfoFormRef"
            :query="baseInfoData"
            :columns="baseColumns"
            :isQueryPanel="false"
            :isDisabledForm="disableBaseFormData"
            labelWidth="150px"
            @changeMethod="changeValueHandler"
            :rules="origin == 'record' ? {} : baseRules"
          >
          </SiruiSearch>
          <!-- <formItem
            ref="baseInfoFormRef"
            :params="baseInfoData"
            :columns="baseColumns"
            :rules="baseRules"
            :disabled="disableBaseFormData"
            @changeValueHandler="changeValueHandler"
            labelWidth="150px"
            @departmentChanged="departmentChangeHandler"
          >
          </formItem> -->
          <div class="radio-group-buttons">
            <el-form
              :model="baseInfoData"
              :rules="baseRules"
              :disabled="disableBaseFormData"
              ref="productServiceRef"
            >
              <el-form-item label="产品类型" prop="productType">
                <el-checkbox-group v-model="checkedProductTypes" @change="handleProductTypeChange">
                  <el-checkbox v-for="item in productTypeList" :label="item.label" :key="item.value"
                    >{{ item.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="服务类型" prop="serviceTypeCode">
                <el-checkbox-group v-model="checkedServiceTypes" @change="handleServiceTypeChange">
                  <el-checkbox
                    v-for="item in serviceTypeDictList"
                    :label="item.label"
                    :key="item.value"
                    :disabled="item.disabled"
                    >{{ item.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-collapse-item>
      <el-tabs class="formTabs" type="border-card" v-model="activeTabName">
        <el-tab-pane label="合作伙伴" name="partnerDetailTab">
          <PartnerDetailChart
            :tableDataList="upPartners"
            @handleChartChange="handleChartChange"
            partnerType="上游"
            ref="upPartnerChartRef"
            :disabled="disableButtons || disablePartners"
          >
          </PartnerDetailChart>
          <PartnerDetailChart
            :tableDataList="downPartners"
            @handleChartChange="handleChartChange"
            partnerType="下游"
            ref="downPartnerChartRef"
            :disabled="disableButtons || disablePartners"
          >
          </PartnerDetailChart>
        </el-tab-pane>
        <el-tab-pane label="运输货物及线路" name="freightAndRouteDetailTab">
          <FreightDetailChart
            :tableDataList="cargos"
            @handleChartChange="handleChartChange"
            :disabled="disableButtons"
          >
          </FreightDetailChart>
          <RouteDetailChart
            :tableDataList="routes"
            @handleChartChange="handleChartChange"
            :disabled="disableButtons"
          >
          </RouteDetailChart>
        </el-tab-pane>
        <el-tab-pane label="服务询报价" name="serviceFeeTab">
          <ServiceFeeChart
            :tableDataList="serviceQuotations"
            :routes="routes"
            :cargos="cargos"
            :selectedServices="checkedServiceTypes"
            :selectedProducts="checkedProductTypes"
            @handleChartChange="handleChartChange"
            :disabled="disableButtons"
          >
          </ServiceFeeChart>
        </el-tab-pane>
        <template v-if="pageMode != 0">
          <el-tab-pane label="关联客户合同" name="assoCusContractTab">
            <AssoContractChart
              chartType="customer"
              :projectCode="this.baseInfoData.projectCode"
              @assoChanged="assoChanged"
            >
            </AssoContractChart>
          </el-tab-pane>
          <el-tab-pane label="关联供方合同" name="assoOrderTab">
            <AssoContractChart chartType="supplier" :projectCode="baseInfoData.projectCode">
            </AssoContractChart>
          </el-tab-pane>
          <el-tab-pane label="关联订单列表" name="assoSupplierTab">
            <AssoOrderChart :projectCode="baseInfoData.projectCode"></AssoOrderChart>
          </el-tab-pane>
          <el-tab-pane
            v-if="pageMode != 0 && origin != 'record'"
            label="变更历史"
            name="projectRecord"
          >
            <ChangeRecord :projectCode="baseInfoData.projectCode"></ChangeRecord>
          </el-tab-pane>
          <!-- <el-tab-pane label="审批记录" name="assoAuditionRecordTab">
            <AuditionRecordChart :code="baseInfoData.projectCode"></AuditionRecordChart>
          </el-tab-pane> -->
        </template>
      </el-tabs>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <FileTable
            ref="fileTableRef"
            :attachments="attachments"
            :isShowDownBtn="uploadDisabled"
            :isDisabledDelete="deleteFileDisabled"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 底部按钮 fixme需要判断立项状态显示-->
    <footer v-if="origin != 'record'" class="bottomButtons">
      <DetailFooterButtonsVue
        @btnHandler="btnHandler"
        :pageMode="pageMode"
        :projectStatus="getProjectStatusName"
      />
    </footer>
    <ProjectRevokeDialog ref="revokeDialogRef" @handleSure="handleRevoke"></ProjectRevokeDialog>
    <ProjectToContractDialog
      ref="toContractDialogRef"
      @handleSure="getContractType"
    ></ProjectToContractDialog>
    <SelectPartnerDialog
      ref="selectPartnerDialogRef"
      @confirm="getPartnerType"
    ></SelectPartnerDialog>
    <CommonTextDialog ref="textDialog"></CommonTextDialog>
  </div>
</template>

<script>
  // import formItem from '../../common/components/form-item.vue';
  import ProjectFormStatusMixin from '@/pages/intermodality/project/projectDetail/ProjectFormStatusMixin';
  import { baseRules } from './columns/tableRules.js';
  import DetailFooterButtonsVue from './components/DetailFooterButtons.vue';
  import PartnerDetailChart from './components/partnerSelectionChart/index.vue';
  import FreightDetailChart from '@/pages/intermodality/common/charts/freightDetailChart/index.vue';
  import RouteDetailChart from '@/pages/intermodality/common/charts/routeDetailChart/index.vue';
  import ServiceFeeChart from '@/pages/intermodality/common/charts/serviceFeeChart/index.vue';
  import AssoContractChart from './components/associatedContractChart/index.vue';
  import AssoOrderChart from './components/associatedOrderChart/index.vue';
  // import AuditionRecordChart from '@/pages/intermodality/common/charts/auditionRecordChart/index.vue';
  import IntermodalityCommonMixin from '@/pages/intermodality/common/mixins/IntermodalityCommonMixin';
  import ProjectServiceMixin from './ProjectServiceMixin';
  import ProjectRevokeDialog from '@/pages/intermodality/project/projectOverview/components/projectRevokeDialog';
  import ProjectToContractDialog from '@/pages/intermodality/project/projectOverview/components/projectToContractDialog';
  import SelectPartnerDialog from '../projectOverview/components/SelectPartnerDialog.vue';
  import CommonTextDialog from '../../common/components/dialogs/CommonTextDialog.vue';
  import FileTable from '@/components/business/FileTable/index.vue';
  import ChangeRecord from './components/changeRecord/index.vue';
  export default {
    name: 'projectCreation',
    mixins: [ProjectServiceMixin, IntermodalityCommonMixin, ProjectFormStatusMixin],
    components: {
      PartnerDetailChart,
      FreightDetailChart,
      RouteDetailChart,
      ServiceFeeChart,
      AssoContractChart,
      AssoOrderChart,
      // AuditionRecordChart,
      // formItem,
      DetailFooterButtonsVue,
      ProjectRevokeDialog,
      ProjectToContractDialog,
      SelectPartnerDialog,
      CommonTextDialog,
      FileTable,
      ChangeRecord,
    },
    data() {
      return {
        baseRules,
        //0代表创建，1代表详情页查看状态，2代表详情页编辑状态
        activeTabName: 'partnerDetailTab',
        activeCollapses: ['1', '2', '3'],
        pageMode: 0,
      };
    },
    methods: {
      getContractType(val) {
        let isUpOrDown = val;
        let projectCode = this.baseInfoData.projectCode;
        this.$refs.selectPartnerDialogRef.openModal(projectCode, isUpOrDown);
      },
      getPartnerType(partner, query) {
        let partnerCode = query.isUpOrDown == '0' ? partner.upPartnerCode : partner.downPartnerCode;
        this.convertContract(query.isUpOrDown, query.projectCode, partnerCode);
        // this._convert(
        //   val,
        //   this.selectedItems[0].projectCode
        //   // this.selectedItems[0].isConversionContract
        // );
      },
      clearValidate() {
        this.$refs.productServiceRef.clearValidate();
      },

      handleSwitchEditMode() {
        this.pageMode = this.pageMode == 1 ? 2 : 1;
        this.getProcessedBaseColumns(
          this.getStatusName('project', this.baseInfoData.projectStatus),
          this.$route.query?.origin
        );
      },
      async handleRevoke(reason) {
        console.log(reason);
        await this.revoke(this.baseInfoData.projectCode, reason);
        this.$router.push({ path: '/intermodality/projectMain' });
      },
      btnHandler(name, params) {
        switch (name) {
          case 'save':
            //0保存1提交
            this.save(this.baseInfoData, this.cargos, this.routes, this.serviceQuotations, params);
            break;
          case 'edit':
            if (this.getProjectStatusName == '执行中') {
              // if (!this.allContractDisabled) {
              //   this.$message({
              //     showClose: true,
              //     message: '由于此项目下已经关联合同，若需要修改项目，则需要停用此项目下的合同！',
              //     type: 'error',
              //   });
              //   return;
              // }
            }
            this.handleSwitchEditMode();
            break;
          case 'view':
            this.handleSwitchEditMode();
            break;
          case 'cancel':
            this.$router.push({ path: '/intermodality/projectMain' });
            break;
          case 'revoke':
            this.$refs.revokeDialogRef.openDialog();
            break;
          case 'convert':
            this.$refs.toContractDialogRef.openDialog();
            break;
          default:
            break;
        }
      },

      async init() {
        await this.getCommonDicts();
        await this.initDetail();
        console.log('获取详情数据', this.baseInfoData.projectSort);
      },
    },
    computed: {
      disableBaseFormData() {
        return this.pageMode == 1;
      },
      disableButtons() {
        return this.pageMode == 1;
      },
      getProjectStatusName() {
        return this.getStatusName('project', this.baseInfoData.projectStatus);
      },
    },
    mounted() {
      if (this.$route.query?.pageMode) {
        this.pageMode = Number(this.$route.query?.pageMode);
      }
      if (this.$route.query?.origin) {
        this.origin = this.$route.query?.origin;
      }
      this.init();
    },
  };
</script>

<style lang="scss" scoped>
  .btn-group {
    padding: 20px 0px;
    box-sizing: border-box;
  }

  .footer-bottom-list {
    justify-content: center;
    display: flex;
    padding-top: 20px;
  }

  .bottomButtons {
    padding-top: 20px;
    text-align: center;
  }
</style>
